import API from "../api";

export const PARTNER_SPECIALTY_OPTIONS = [
  { key: "bodywork", label: "Carrosserie" },
  { key: "smart_repair", label: "Smart repair" },
  { key: "dent_repair", label: "Débosselage" },
  { key: "wheel_repair", label: "Réparation jantes" },
  { key: "wheel_painting", label: "Peinture jantes" },
  { key: "detailing", label: "Detailing" },
  { key: "interior_cleaning", label: "Nettoyage intérieur" },
  { key: "exterior_cleaning", label: "Nettoyage extérieur" },
  { key: "vehicle_prep", label: "Préparation véhicule" },
  { key: "polishing", label: "Polissage / lustrage" },
  { key: "convoying", label: "Convoyage" },
];

export const PARTNER_STATUS_LABELS = {
  pending_review: "En attente de vérification",
  interview_required: "Entretien requis",
  approved: "Partenaire vérifié",
  refused: "Dossier refusé",
  suspended: "Compte suspendu",
};

export async function fetchPartnerMe() {
  const { data } = await API.get("/api/partners/me");
  return data;
}

export async function registerPartner(formData) {
  const { data } = await API.post("/api/partners/register", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export async function enrollPartner(formData) {
  const { data } = await API.post("/api/partners/enroll", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export async function updatePartner(formData) {
  const { data } = await API.put("/api/partners/update", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}
